import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { RoutesEnum } from '@/enums/routes.enum';

export const NavWrapper = styled('div')(() => {
  const { pathname } = useLocation();
  return {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '4px',
    padding: pathname === RoutesEnum.game ? '0' : '0 15px',

    ':first-child': {
      borderRadius: '8px 0 0 0',
    },
    ':last-child': {
      borderRadius: '0 8px 0 0',
    },
  };
});

export const MobileNavWrapper = styled('div')({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
});

export const StyledLink = styled(Link)<{ selected?: boolean }>(
  ({ theme, selected }) => ({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    background: selected ? theme.colors.primaryRed : theme.colors.darkBlue,
    textTransform: 'uppercase',
    fontSize: '16px',
    fontWeight: '600',
    color: theme.colors.white,
    textDecoration: 'none',
    justifyContent: 'center',
    height: '45px',
    borderRadius: '0',
  })
);

export const MobileStyledLink = styled(Link)<{ selected?: boolean }>(
  ({ theme, selected }) => ({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    background: theme.colors.darkBlue,
    textTransform: 'uppercase',
    fontSize: '16px',
    fontWeight: '600',
    color: theme.colors.white,
    textDecoration: 'none',
    justifyContent: 'center',
    height: '40px',
    borderRadius: '0',
    borderBottom: '3px solid',
    borderColor: selected ? theme.colors.primaryRed : theme.colors.darkBlue,
  })
);
